import { Component, Inject, PLATFORM_ID, Renderer2 } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import * as AOS from 'aos';
import { Constants } from '../../common/constants';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { SeoService } from 'src/app/common/seo.service';

@Component({
  selector: 'app-cloud-planning-services',
  templateUrl: './cloud-planning-services.component.html',
  styleUrls: ['./cloud-planning-services.component.css']
})
export class CloudPlanningServicesComponent {
  isBrowser:boolean=false;
  baseUrl = Constants.baseUrl;

   constructor(
    private titleService: Title,  @Inject(PLATFORM_ID) private platformId: any,
    private seoService:SeoService,
  
    private metaService: Meta
  ) {this.isBrowser=isPlatformBrowser(this.platformId);}
  ngOnInit(): void {
    
      this.setTitleAndMetaTags();
      this.seoService.createLinkForCanonicalURL();
    
    if(this.isBrowser){     
  AOS.init({disable: 'mobile', duration: 2000, delay: 500,});
}
  
  }
  private setTitleAndMetaTags(): void {
    this.titleService.setTitle('Cloud Hosting & Cloud Computing Services | Maganti IT');
    this.metaService.addTags([
      { name: 'description', content: 'Bring your business into the cloud with customized cloud hosting services and cloud computing solutions including private, public and hybrid cloud services.' },
      { property: 'og:type', content: 'website' },
      { property: 'og:title', content: 'Cloud Hosting & Cloud Computing Services | Maganti IT' },
      { property: 'og:url', content: 'https://mitresource.com/artificial-Intelligence/' },
      { property: 'og:image', content: 'https://mitresource.com/assets/images/banners/mit-favicon.png' },
      { property: 'og:description', content: 'Bring your business into the cloud with customized cloud hosting services and cloud computing solutions including private, public and hybrid cloud services.' },
    ]);
  }
}
